import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  container: css`
    box-shadow: none;
    && {
      background: transparent;
    }
  `,
}
